module.exports = __webpack_public_path__ + "static/media/armadillo-booking-3.b7029422.jpg";